import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function isColumnStyle({ $isColumn }: ButtonStyleProps) {
  if ($isColumn) {
    return css`
      > * {
        flex-direction: column;

        > * {
          padding: 0.5rem 0;

          &:first-child {
            padding-top: 0;
          }

          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    `;
  }
}
